//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Award from "@/components/UI/award";
import { conversion, countDownS, GetItemDuration, formatDate } from "@/tool";
import { mapGetters } from "vuex";

export default {
  name: "battleCaseDetail",
  components: {
    "c-award": Award,
  },
  filters: {
    conversion,
    GetItemDuration,
    
  },
  computed: {
  },
  props: {
    caseInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
